document.addEventListener('DOMContentLoaded', function() {
  const shapeRadioButtons = document.querySelectorAll('input[name="properties[Shape]"]');
  const customShapeDetailsWrapper = document.getElementById('custom-shape-details-wrapper');
  const customShapeDetailsInput = document.getElementById('custom-shape-details');

  if (shapeRadioButtons.length > 0 && customShapeDetailsWrapper) {
    function toggleCustomShapeDetails() {
      const selectedValue = document.querySelector('input[name="properties[Shape]"]:checked').value;
      
      if (selectedValue === 'Custom') {
        customShapeDetailsWrapper.style.display = 'block';
      } else {
        customShapeDetailsWrapper.style.display = 'none';
        customShapeDetailsInput.value = ''; // Clear the input when not needed
      }
    }

    shapeRadioButtons.forEach(function(radio) {
      radio.addEventListener('change', toggleCustomShapeDetails);
    });

    // Run once on page load to set the initial state
    toggleCustomShapeDetails();
  }
});